import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
	components: {
		MuiCssBaseline: {
			styleOverrides: (themeParam) => ({
				'html, body, #root': {
					width: '100%',
					height: '100%',
					fontFamily: `'ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', '游ゴシック', 'Yu Gothic', 'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif`,
				},
				a: {
					textDecoration: 'none',
				},
			}),
		},
		MuiButton: {
			styleOverrides: {
				root: {
					textTransform: 'none',
				},
				contained: {
					border: '1px solid #2e7d32'
				},
				outlined: {
					backgroundColor: '#fff',
					padding: '6px 16px',
					'&:hover': {
						backgroundColor: '#fff',
					}
				},
			},
		},
	},
});
